import { type ReactNode } from "react";
import { Navigate } from "react-router";
import { ORGANIZATION, useFoodpilotContext } from "src/context/FoodpilotContext";
import type { Slugs } from "src/context/ProtectedContext";

type OrganizationAdministrationProtectionProps = {
    action: Slugs;
    children: ReactNode;
};

export const OrganizationAdministrationProtection = (props: OrganizationAdministrationProtectionProps) => {
    const { action, children } = props;
    const { canUser } = useFoodpilotContext();

    if (!canUser(action, ORGANIZATION)) {
        return <Navigate to="/settings" replace />;
    }

    return children;
};
